/**
 * GTP column letters. `I` is skipped, by convention, so it cannot be misread as
 * `1` or `J` on a board diagram.
 */
export const GTP_LETTERS = "ABCDEFGHJKLMNOPQRSTUVWXYZ".split("");
